module.exports = __webpack_public_path__ + "img/组 192.127ce55f.png";